webpackJsonp([13,35],{

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (config) {
	  this.distanceX = 0;
	  this.distanceY = 0;
	  this.startPos = [0, 0];
	  this.currentPos = [0, 0];
	  this.startTime = 0;
	  this.endTime = 0;
	  this.speedX = 0;
	  this.speedY = 0;
	
	  this.state = 'FREE';
	  this.alias = config.alias || '';
	  this.dom = config.dom;
	  this.eventType = config.type || 'swipe';
	  this.callback = config.doing || function () {};
	  this.donecallback = config.done || function () {};
	
	  this.mode = config.mode || 'strict';
	
	  var t = this;
	
	  this.handleTouchStart = function (e) {
	    t.startTime = new Date().getTime();
	    t.state = 'START';
	    var touch = e.targetTouches[0];
	    t.startPos = [touch.pageX, touch.pageY];
	
	    t.callback('touchstart', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.startPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchMove = function (e) {
	    t.state = 'MOVING';
	    var touch = e.targetTouches[0];
	    t.currentPos = [touch.pageX, touch.pageY];
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	    t.callback('touchmove', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.currentPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchEnd = function () {
	    t.state = 'END';
	    t.endTime = new Date().getTime();
	    var time = Math.floor((t.endTime - t.startTime) / 1000);
	
	    if (t.currentPos[0] === 0 || t.currentPos[1] === 0) {
	      t.currentPos = t.startPos;
	    }
	
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	
	    if (time === 0) time = 1;
	    t.speedX = Math.abs(t.distanceX / time);
	    t.speedY = Math.abs(t.distanceY / time);
	
	    if (!t.actions[t.eventType]()) {
	      t.callback('touchend', {
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    } else {
	      if (t.mode === 'unstrict') {
	        t.callback('touchend', {
	          distance: { x: t.distanceX, y: t.distanceY },
	          speed: { x: t.speedX, y: t.speedY },
	          position: t.currentPos,
	          state: t.state,
	          alias: t.alias
	        });
	      }
	
	      t.donecallback({
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    }
	
	    t.state = 'FREE';
	    t.distanceX = 0;
	    t.distanceY = 0;
	    t.startTime = 0;
	    t.endTime = 0;
	    t.speedX = 0;
	    t.speedY = 0;
	    t.startPos = [0, 0];
	    t.currentPos = [0, 0];
	  };
	
	  this.actions = {
	    swipe: function swipe() {
	      return true;
	    },
	    swipeDown: function swipeDown() {
	      if (t.distanceY > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeUp: function swipeUp() {
	      if (t.distanceY < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeLeft: function swipeLeft() {
	      if (t.distanceX < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeRight: function swipeRight() {
	      if (t.distanceX > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeX: function swipeX() {
	      if (Math.abs(t.distanceX) > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeY: function swipeY() {
	      if (Math.abs(t.distanceY) > 60) {
	        return true;
	      }
	      return false;
	    }
	  };
	
	  this.init = function () {
	    this.dom.addEventListener('touchstart', this.handleTouchStart);
	    this.dom.addEventListener('touchmove', this.handleTouchMove);
	    this.dom.addEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.destory = function () {
	    this.dom.removeEventListener('touchstart', this.handleTouchStart);
	    this.dom.removeEventListener('touchmove', this.handleTouchMove);
	    this.dom.removeEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.init();
	};

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(15),
	  /* template */
	  __webpack_require__(19),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _touchit = __webpack_require__(3);
	
	var _touchit2 = _interopRequireDefault(_touchit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Modal',
	  components: {},
	  props: {
	    mode: {
	      type: String,
	      default: 'swipeDown' }
	  },
	  created: function created() {
	    try {
	      this.pullDistance *= window.r || 1;
	    } catch (e) {
	      this.pullDistance *= 1;
	    }
	
	    this.touchit = new _touchit2.default({
	      dom: document.body,
	      type: this.mode,
	      done: this.loading,
	      doing: this.handleTouch
	    });
	  },
	
	  methods: {
	    reset: function reset() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.pullState = 0;
	      }, 300);
	
	      this.move(0);
	      this.isloading = false;
	    },
	    move: function move(distance) {
	      this.$refs.list.style.transform = 'translate(0px, ' + distance + 'px)';
	    },
	    loading: function loading() {
	
	      this.isloading = true;
	      this.pullState = 4;
	      this.distance = 0;
	      if (this.mode === 'swipeUp') {
	        this.move(-this.pullDistance);
	      }
	      if (this.mode === 'swipeDown') {
	        this.move(this.pullDistance);
	      }
	      this.$emit('on-loading', this);
	    },
	    handleTouch: function handleTouch(eventType, data) {
	      var _this2 = this;
	
	      switch (eventType) {
	        case 'touchstart':
	          {
	            break;
	          }
	        case 'touchmove':
	          {
	            var isRight = true;
	
	            if (Math.abs(this.distance) < this.pullDistance + 50) {
	              this.distance = data.distance.y;
	              this.move(this.distance);
	            }
	
	            switch (this.mode) {
	
	              case 'swipeUp':
	                {
	
	                  if (data.distance.y < 0) {
	                    isRight = true;
	                    this.pullState = 2;
	                  } else {
	                    isRight = false;
	                    this.pullState = 0;
	                  }
	                  break;
	                }
	              case 'swipeDown':
	                {
	                  if (data.distance.y > 0) {
	                    isRight = true;
	                    this.pullState = 1;
	                  } else {
	                    isRight = false;
	                    this.pullState = 0;
	                  }
	                  break;
	                }
	              default:
	                {
	                  break;
	                }
	            }
	
	            if (Math.abs(data.distance.y) > this.pullDistance && isRight) {
	              this.pullState = 3;
	            }
	
	            break;
	          }
	        case 'touchend':
	          {
	            this.distance = 0;
	
	            setTimeout(function () {
	              _this2.pullState = 0;
	            }, 300);
	
	            this.move(0);
	            break;
	          }
	        default:
	          {
	            break;
	          }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      touchit: null,
	      isloading: false,
	      notice: ['', '下拉刷新列表', '上拉刷新列表', '松开刷新', '加载中'],
	      pullState: 0,
	      distance: 0,
	      pullDistance: 60
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.touchit.destory();
	  }
	};

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "list",
	    staticClass: "list-hack"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pullState > 0 && _vm.mode === 'swipeDown'),
	      expression: "pullState>0&&mode==='swipeDown'"
	    }],
	    staticClass: "down-fresh"
	  }, [_c('p', [_c('i', {
	    staticClass: "icon iconfont icon-loading",
	    class: [
	      _vm.isloading ? 'loading' : ''
	    ]
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notice[_vm.pullState]))])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pullState > 0 && _vm.mode === 'swipeUp'),
	      expression: "pullState>0&&mode==='swipeUp'"
	    }],
	    staticClass: "up-fresh"
	  }, [_c('p', [_c('i', {
	    staticClass: "icon iconfont icon-loading",
	    class: [
	      _vm.isloading ? 'loading' : ''
	    ]
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notice[_vm.pullState]))])])]), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'page',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(23),
	  /* template */
	  __webpack_require__(37),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(124),
	  /* template */
	  __webpack_require__(233),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _list = __webpack_require__(12);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _page = __webpack_require__(30);
	
	var _page2 = _interopRequireDefault(_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'listdemo',
	  components: {
	    List: _list2.default,
	    Page: _page2.default
	  },
	  data: function data() {
	    return {
	      datas: [{
	        id: 1,
	        content: '标题1'
	      }]
	    };
	  },
	
	  methods: {
	    loading: function loading(obj) {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.datas.push({
	          id: 2,
	          content: '\u6807\u9898' + (_this.datas.length + 1)
	        });
	        obj.reset();
	      }, 1000);
	    }
	  }
	};

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('list', {
	    attrs: {
	      "mode": "swipeUp"
	    },
	    on: {
	      "on-loading": _vm.loading
	    }
	  }, _vm._l((_vm.datas), function(item) {
	    return _c('li', {
	      staticClass: "list-item list-item-arrow m1111"
	    }, [_c('div', {
	      staticClass: "card p2222"
	    }, [_c('div', {
	      staticClass: "card-content"
	    }, [_c('p', [_vm._v("\n          " + _vm._s(item.content) + "\n        ")])])])])
	  }))
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.46552e110f2861399a1a.js